import { postProcessMFHPortfolioEvent } from '@/api/mfh/mfh-portfolio-process.api';
import type { MFHPortfolioEvents, MFHPortfolioProcessType } from '@condo/domain';
import { useDialog } from 'naive-ui';
import { mfhPortfolioEventToHuman } from '../../shared/filters';
import { ToastType, confirmDialog, showToast } from '../../shared/helpers';

export interface ITriggerMfhPortfolioParams {
    mfhPortfolioId: number;
    processType: MFHPortfolioProcessType;
    processId: number;
    event: MFHPortfolioEvents;
    eventDate: Date;
    additionalData?: Record<string, any>;
}

export const useTriggerMfhPortfolioEvent = () => {
    const dialog = useDialog();

    const triggerEvent = async (params: ITriggerMfhPortfolioParams) => {
        const { result: decision } = await confirmDialog(dialog, {
            title: 'Confirm state transition!',
            content: `Are you sure you want to trigger <b>${mfhPortfolioEventToHuman(params.event)}</b> for current MFH Portfolio?`,
            okButton: { text: 'Trigger!', cssClass: '' },
        });

        if (decision) {
            showToast(`Event: '${mfhPortfolioEventToHuman(params.event)}' triggered!`, ToastType.SUCCESS, 10000);

            try {
                await postProcessMFHPortfolioEvent({
                    mfhPortfolioId: params.mfhPortfolioId,
                    processType: params.processType as any as MFHPortfolioProcessType,
                    processId: params.processId,
                    event: params.event,
                    eventDate: params.eventDate,
                    additionalData: params.additionalData,
                });

                return true;
            } catch (_) {
                showToast('Failed to trigger event!', ToastType.ERROR, 10000);
            }
        }
        return false;
    };

    return triggerEvent;
};
